import { canReviewAccessRequests } from '@infras/shared-types';
import { AdminGate } from '../components/AdminGate';
import { AccessReviewers } from '../components/AccessReviewers';
import { useMe } from '../lib/useMe';

/** Administration → Access reviewers: the layered roster the request form and the
 *  request-access docs both render live. */
export function AccessReviewersPage() {
  const { me } = useMe();
  return (
    <AdminGate allowed={!!me && canReviewAccessRequests(me.role)} need="reviewers and root users">
      <div className="page stack access-admin-page">
        <div className="detail-head">
          <h2>Access reviewers</h2>
        </div>
        <p className="detail-desc">
          Layer 1 is auto-assigned on every new request; higher layers are reached by manual
          escalation. This roster is what the request form and the docs page show.
        </p>
        <AccessReviewers />
      </div>
    </AdminGate>
  );
}
